"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _x = _interopRequireDefault(require("@spothero/icons/x"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
var _Button = _interopRequireDefault(require("../v1/components/Button/Button"));
var _Portal = _interopRequireDefault(require("../Portal/Portal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Flyout extends _react.Component {
  static defaultProps = {
    closeOnShimClick: true
  };
  componentDidMount() {
    const {
      isBackgroundScrollable
    } = this.props;
    setTimeout(() => {
      this._isAnimating = true;
      if (!isBackgroundScrollable) {
        _dom.default.addClass('html', 'Flyout-no-scroll');
      }
      _dom.default.addClass(this._flyout, 'Flyout-active');
      window.transitionEnd(this._flyout).bind(() => {
        window.transitionEnd(this._flyout).unbind();
        this._isAnimating = false;
      });
    }, 100);
  }
  componentWillUnmount() {
    this._removeClasses();
  }
  _onCloseClick = evt => {
    if (this._isAnimating) {
      return;
    }
    this.hide();
  };
  _removeClasses() {
    _dom.default.removeClass('html', 'Flyout-open Flyout-no-scroll');
    _dom.default.removeClass(this._flyout, 'Flyout-active');
  }

  /**
   * Hides the Flyout programmatically.
   *
   * @public
   * @param {*} args - The arguments to pass to the onHidden callback in cases where you may need access to something not available in Flyout itself.
   * @returns {void}
   */
  hide(...args) {
    this._isAnimating = true;
    const {
      onHidden
    } = this.props;
    this._removeClasses();
    window.transitionEnd(this._flyout).bind(() => {
      window.transitionEnd(this._flyout).unbind();
      this._isAnimating = false;
      if (onHidden) {
        onHidden(...args);
      }
    });
  }
  render() {
    const {
      title,
      children,
      // eslint-disable-next-line no-unused-vars
      onHidden,
      className,
      closeOnShimClick,
      // eslint-disable-next-line no-unused-vars
      isBackgroundScrollable,
      ...props
    } = this.props;
    const classes = (0, _classnames.default)('Flyout-container', className);
    return /*#__PURE__*/_react.default.createElement(_Portal.default, {
      className: "Flyout"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, closeOnShimClick && /*#__PURE__*/_react.default.createElement("div", {
      className: "Flyout-shim",
      onClick: this._onCloseClick
    }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      ref: node => {
        this._flyout = node;
      },
      className: "Flyout-wrapper"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "Flyout-heading"
    }, (0, _isString.default)(title) ? /*#__PURE__*/_react.default.createElement("h1", {
      className: "heading-sm"
    }, title) : title, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "Flyout-close",
      "aria-label": "Close Flyout",
      onClick: this._onCloseClick
    }, /*#__PURE__*/_react.default.createElement(_x.default, null))), /*#__PURE__*/_react.default.createElement("div", {
      className: "Flyout-content"
    }, children))));
  }
}
exports.default = Flyout;